import { motion, Variants, easeOut } from "framer-motion";

const textVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const containerVariants: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const cardVariants: Variants = {
  hidden: { opacity: 0, scale: 0.9, y: 20 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { duration: 0.5, ease: easeOut },
  },
};

export const Funcionalidade = () => {
  return (
    <>
      <section
        id="como-funciona"
        className="container px-4 sm:px-6 md:px-10 max-w-7xl"
      >
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={containerVariants}
          className="mb-10"
        >
          <motion.h2
            variants={textVariants}
            className="text-3xl font-bold text-gray-900 mb-2 md:text-5xl"
          >
            Como funciona
          </motion.h2>
          <motion.p
            variants={textVariants}
            className="text-lg text-gray-700 mb-10 md:text-3xl"
          >
            Seu pedido em poucos passos:
          </motion.p>
        </motion.div>
      </section>

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={containerVariants}
        className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5 justify-center"
      >
        {[
          {
            title: "Personalização",
            desc: "Escolha o tamanho, dados e estilo da gravação",
            img: "/img/personalizar.png",
          },
          {
            title: "Alta durabilidade",
            desc: "Nossas anilhas são leves, resistentes e não machucam a ave",
            img: "/img/durabilidade.png",
          },
          {
            title: "Marcação a laser",
            desc: "Precisão milimétrica e visual impecável",
            img: "/img/laser.png",
          },
          {
            title: "Envio rápido",
            desc: "Receba seu pedido com agilidade em todo o Brasil",
            img: "/img/envio.png",
          },
        ].map((item, index) => (
          <motion.div
            key={index}
            variants={cardVariants}
            className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 mx-auto max-w-[320px] w-full"
          >
            <div className="flex flex-col items-center text-center">
              <img
                src={item.img}
                alt={item.title}
                className="h-20 object-contain mb-4"
              />
              <h3 className="text-lg font-semibold">{item.title}</h3>
              <p className="text-sm text-gray-600 mt-1">{item.desc}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </>
  );
};
